import {
  CircularProgress,
  Paper,
  TableRow,
  IconButton,
  LinearProgress,
  Collapse
} from "@mui/material";
import {
  TableCell,
  Table,
  TableBody,
  TableContainer,
  TableHead
} from "../base/table";
import Alert from "../base/alert";
import Typography from "../base/typography";
import Modal from "../base/modal";
import { BaseButton } from "../base";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import DescriptionIcon from "@mui/icons-material/Description";
import { Box } from "@mui/system";
import React, { useRef, useContext, useEffect, useState } from "react";
import UserContext from "../../services/user/user";

import UploadFileIcon from "@mui/icons-material/UploadFile";

import { URLS } from "../../configuration/urls";

import { FormattedMessage } from "react-intl";

// import axios from "axios";

import {
  EcUserDataContext,
  ECAxiosAPI,
  formattedDateTime
} from "@eclear-ag/ec-common-ui";

import messages_de from "../../translations/de.json";
import messages_en from "../../translations/en.json";
import messages_es from "../../translations/es.json";
import messages_fr from "../../translations/fr.json";

export default function DataFiles() {
  const { lang } = useContext(UserContext);
  const { userData } = useContext(EcUserDataContext);
  const [tableData, setTableData] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [file, setFile] = useState({
    file: null,
    fileName: "",
    size: 0,
    type: ""
  });
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isBtnUploadDisable, setIsBtnUploadDisable] = useState(false);

  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) =>
  //       prevProgress >= 100 ? 10 : prevProgress + 10
  //     );
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  // React.useEffect(() => {
  //   if (progress === 100) {
  //     setIsUploading(false);
  //   }
  // }, [progress]);

  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };

  const tableRef = useRef();

  const modalStyle = {
    position: "absolute",
    top: "25%",
    left: "50%",
    transform: "translate(-50%, -25%)",
    width: "76%"
  };

  const getFilesList = async () => {
    setIsTableLoading(true);
    const filesList = await ECAxiosAPI.get(
      `${URLS.EC_SPOT_BE()}${URLS.DATA_FILES_LIST(userData.companyId)}`
    )
      .then((res) => {
        if (res.length === 0) {
          setIsEmpty(true);
        } else {
          setTableData(filesList);
          setIsEmpty(false);
        }
        setIsTableLoading(false);
      })
      .catch((err) => {
        setIsEmpty(true);
        setIsTableLoading(false);
      });
  };

  useEffect(() => {
    if (userData.companyId) {
      getFilesList();
    }
  }, [userData]);

  useEffect(() => {
    isAlertVisible === true &&
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
  }, [isAlertVisible]);

  function bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }

  const [dragActive, setDragActive] = React.useState(false);

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    // console.log("__ File: ", e.dataTransfer.files[0]);
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile({
        file: e.dataTransfer.files[0],
        fileName: e.dataTransfer.files[0].name,
        size: e.dataTransfer.files[0].size,
        type: e.dataTransfer.files[0].type
      });
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setFile({
        file: e.target.files[0],
        fileName: e.target.files[0].name,
        size: e.target.files[0].size,
        type: e.target.files[0].type
      });
    }
  };

  const handleFileUpload = async (e) => {
    setProgress(0);
    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", file.file);
    await ECAxiosAPI.post(
      `${URLS.EC_MEDIA_BE()}${URLS.UPLOAD_DATA_FILE}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      }
    )
      .then((res) => {
        setFile({ file: null, fileName: "", size: 0, type: "" });
        setIsUploadSuccess(true);
      })
      .catch((err) => {
        setIsUploadSuccess(false);
      });
    setIsUploading(false);
    setIsAlertVisible(true);
    getFilesList();
    setTimeout(() => {
      setIsAlertVisible(false);
    }, 8000);
  };

  const fileType = "application/json, text/csv";

  return (
    <Box>
      <BaseButton
        startIcon={<UploadFileIcon size="1.5rem" />}
        variant="filled"
        sx={{ mt: 2, mb: 3 }}
        onClick={() => {
          setOpenModal(true);
        }}
      >
        <span style={{ marginLeft: "3px" }}>
          <FormattedMessage id="uploadFile" />
        </span>
      </BaseButton>

      <Paper
        sx={{
          backgroundColor: isEmpty ? "rgba(0, 24, 61, 0.08)" : "info.light",
          borderRadius: "10px"
        }}
        className="widget-col-6 widget-row-2 top-countries"
        elevation={0}
      >
        <Box sx={{ textAlign: "center" }}>
          {isTableLoading ? (
            <CircularProgress />
          ) : (
            <TableContainer ref={tableRef} style={{ borderRadius: "10px" }}>
              <Table aria-label="data files table">
                <TableHead sx={{ borderTop: "2px solid #e8ebef" }}>
                  <TableRow>
                    {/* <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        borderLeft: "0px",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px",
                      }}
                    >
                      <FormattedMessage id="ID" />
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px",
                      }}
                    >
                      <span style={{ marginLeft: "8px" }}>
                        <FormattedMessage id="merchantId" />
                      </span>
                    </TableCell> */}
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <span style={{ marginLeft: "8px" }}>
                        <FormattedMessage id="fileName" />
                      </span>
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px",
                      }}
                    >
                      <FormattedMessage id="s3FileName" />
                    </TableCell> */}
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <FormattedMessage id="contentType" />
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <FormattedMessage id="size" />
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <FormattedMessage id="status" />
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <FormattedMessage id="createdAt" />
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px",
                      }}
                    >
                      <FormattedMessage id="createdBy" />
                    </TableCell> */}
                    <TableCell
                      sx={{
                        borderRight: "2px solid #e8ebef",
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px"
                      }}
                    >
                      <FormattedMessage id="modifiedAt" />
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        border: isEmpty && "2px solid rgba(0, 24, 61, 0.2)",
                        borderRight: "0px",
                        textAlign: "center",
                        fontWeight: 500,
                        padding: "10px",
                        color: isEmpty && "#b3bac5",
                        borderTop: "0px",
                      }}
                    >
                      <FormattedMessage id="modifiedBy" />
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isEmpty === true ? (
                    <TableRow hover style={{ height: "40px" }}>
                      <TableCell
                        colSpan={11}
                        sx={{
                          textAlign: "center",
                          fontWeight: 400,
                          padding: 0,
                          fontSize: "14px",
                          color: "#687389"
                        }}
                      >
                        <FormattedMessage id="noDataFiles" />
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableData.map((row, index) => (
                      <TableRow hover key={index} style={{ height: "40px" }}>
                        {/* <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            textAlign: "center",
                            fontWeight: 400,
                            padding: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {row.id}
                        </TableCell> */}
                        {/* <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            fontWeight: 400,
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {row.merchantId}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            fontWeight: 400,
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          {row.fileName}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            textAlign: "center",
                            fontWeight: 400,
                            padding: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {row.s3FileName}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            textAlign: "center",
                            fontWeight: 400,
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          {row.contentType}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            fontWeight: 400,
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          {bytesToSize(row.size)}
                        </TableCell>
                        <TableCell
                          style={{
                            borderRight: "2px solid #e8ebef",
                            fontWeight: 400,
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          <FormattedMessage id={row.status} />
                        </TableCell>
                        <TableCell
                          style={{
                            borderRight: "2px solid #e8ebef",
                            fontWeight: 400,
                            textAlign: "center",
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          {formattedDateTime(row.createdAt)}
                        </TableCell>
                        {/* <TableCell
                          style={{
                            borderRight: "2px solid #e8ebef",
                            textAlign: "center",
                            fontWeight: 400,
                            padding: "10px",
                            fontSize: "14px",
                          }}
                        >
                          {row.createdBy}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            borderRight: "2px solid #e8ebef",
                            textAlign: "center",
                            fontWeight: 400,
                            padding: "10px",
                            fontSize: "14px"
                          }}
                        >
                          {formattedDateTime(row.modifiedAt)}
                        </TableCell>
                        {/* <TableCell
                          sx={{
                            padding: "10px",
                            fontSize: "14px",
                            borderRight: "0px",
                          }}
                        >
                          {row.modifiedBy}
                        </TableCell> */}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Paper>

      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={{ textAlign: "right" }}>
            <IconButton
              aria-label="data files modal"
              onClick={() => {
                setOpenModal(false);

                if (isUploading === false) {
                  setProgress(0);
                  setIsUploading(false);
                  setFile({
                    file: null,
                    fileName: "",
                    size: 0
                  });
                }
              }}
            >
              <CloseIcon color="primary" />
            </IconButton>
          </Box>

          <Collapse in={isAlertVisible}>
            <Alert
              severity={isUploadSuccess ? "success" : "error"}
              // action={
              //   <IconButton
              //     aria-label="close"
              //     color="inherit"
              //     size="small"
              //     onClick={() => {
              //       setIsAlertVisible(false);
              //     }}
              //   >
              //     <CloseIcon fontSize="inherit" />
              //   </IconButton>
              // }
              sx={{ mb: 2 }}
            >
              <FormattedMessage
                id={isUploadSuccess ? "uploadSuccess" : "uploadError"}
              />
            </Alert>
          </Collapse>

          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "1rem"
            }}
          >
            <form
              id="form-file-upload"
              onDragEnter={handleDrag}
              onSubmit={(e) => e.preventDefault()}
              method="POST"
            >
              <input
                accept={fileType}
                type="file"
                id="input-file-upload"
                multiple={false}
                onChange={handleChange}
                onClick={(e) => {
                  if (file.file === null) {
                    e.target.value = null;
                  }
                }}
              />
              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "var(--container-light)"
                }}
                id="label-file-upload"
                htmlFor="input-file-upload"
                className={
                  dragActive
                    ? "drag-active"
                    : file.size >= 100000000
                      ? "wrong-file"
                      : file.type !== "application/json" &&
                          file.type !== "text/csv" &&
                          file.file !== null
                        ? "wrong-file"
                        : ""
                }
              >
                {file.file === null ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <Typography variant="subtitle">
                      <FormattedMessage id="uploadMessage" />
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ marginTop: "5px" }}
                    >
                      <FormattedMessage id="onlyCsv" />
                    </Typography>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}
                  >
                    <DescriptionIcon
                      style={{
                        alignSelf: "center",
                        fontSize: "5rem",
                        color:
                          file.size >= 100000000
                            ? "rgba(255, 71, 87,1)"
                            : file.type !== "application/json" &&
                                file.type !== "text/csv"
                              ? "rgba(255, 71, 87,1)"
                              : ""
                      }}
                    />
                    <span
                      style={{
                        marginBottom: "10px",
                        color:
                          file.size >= 100000000
                            ? "rgba(255, 71, 87,1)"
                            : file.type !== "application/json" &&
                                file.type !== "text/csv"
                              ? "rgba(255, 71, 87,1)"
                              : ""
                      }}
                    >
                      {file.fileName}
                    </span>
                    {file.size >= 100000000 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center"
                        }}
                      >
                        <ErrorIcon
                          style={{
                            color: "var(--error-white)",
                            marginRight: "5px"
                          }}
                        />
                        <Typography
                          variant="subtitle2"
                          color={"var(--error-white)"}
                        >
                          <FormattedMessage id="fileSizeExceeds" />
                        </Typography>
                      </div>
                    )}
                    {file.type !== "application/json" &&
                    file.type !== "text/csv" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center"
                        }}
                      >
                        <ErrorIcon
                          style={{
                            color: "rgba(255, 71, 87,1)",
                            marginRight: "5px"
                          }}
                        />
                        <Typography
                          variant="subtitle2"
                          color={"rgba(255, 71, 87,1)"}
                        >
                          <FormattedMessage id="incorrectFile" />
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                )}
              </label>
              {dragActive && (
                <div
                  id="drag-file-element"
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                ></div>
              )}
              <Box
                sx={{ display: "flex", alignItems: "center" }}
                className={`progress-bar ${isUploading ? "visible" : ""}`}
              >
                <Box sx={{ width: "100%", mr: 1 }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      backgroundColor: "var(--text-primary)",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "var(--text-primary)"
                      },
                      height: "10px",
                      borderRadius: "6px"
                    }}
                  />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant="body2" primary>{`${Math.round(
                    progress
                  )}%`}</Typography>
                </Box>
              </Box>
              {file.file !== null && (
                <BaseButton
                  variant="text"
                  disabled={isUploading}
                  onClick={() => {
                    setFile({
                      file: null,
                      fileName: "",
                      size: 0
                    });
                  }}
                >
                  <FormattedMessage id="removeFile" />
                </BaseButton>
              )}
            </form>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 15,
              mb: 0,
              pb: 0
            }}
          >
            <BaseButton
              fullWidth
              disabled={isUploading || file.file === null}
              startIcon={<UploadFileIcon size="1.5rem" />}
              variant="filled"
              type="submit"
              onClick={() => {
                // : file.size >= 100000000
                //                 ? "wrong-file"
                //                 : file.type !== "text/csv" &&
                //                   file.type !==
                //                     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                //                   file.file !== null
                //                 ? "wrong-file"
                if (
                  file.file !== null &&
                  file.size <= 100000000 &&
                  (file.type === "application/json" || file.type === "text/csv")
                )
                  handleFileUpload();
              }}
            >
              <span style={{ marginLeft: "3px" }}>
                {" "}
                {isUploading ? (
                  <FormattedMessage id="uploading" />
                ) : (
                  <FormattedMessage id="uploadFile" />
                )}
              </span>
            </BaseButton>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
